import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TenantService {
  public static TENANT_LOCAL_STORAGE_KEY = 'tenant';
  public currentTenantId$ = new BehaviorSubject<string>(undefined);

  public switchTenant(tenantId: string, refreshPage = false): void {
    this.currentTenantId$.next(tenantId);
    this.storeTenant(tenantId);

    if (refreshPage) {
      window.location.assign(`/`);
    }
  }

  public getTenantIdFromUrl(tenantIdPrefix = 'tenant'): string {
    const tenantRegex = `.*${tenantIdPrefix}/([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})`;
    return window.location.href.match(tenantRegex)?.[1];
  }

  public getCurrentTenantId(options: { fallbackToUrl: boolean; tenantIdPrefix?: string } = { fallbackToUrl: false, tenantIdPrefix: 'tenant' }): string {
    if (!this.currentTenantId$.getValue()) {
      const storedTenantId = localStorage.getItem(TenantService.TENANT_LOCAL_STORAGE_KEY);
      if (storedTenantId) {
        this.currentTenantId$.next(storedTenantId);
      } else if (options.fallbackToUrl) {
        const urlTenantId = this.getTenantIdFromUrl(options.tenantIdPrefix);
        if (urlTenantId) {
          this.currentTenantId$.next(urlTenantId);
        }
      }
    }

    return this.currentTenantId$.getValue();
  }

  public storeTenant(tenantId: string): void {
    if (tenantId) {
      this.currentTenantId$.next(tenantId);
      localStorage.setItem(TenantService.TENANT_LOCAL_STORAGE_KEY, tenantId);
    }
  }

  public removeTenant(): void {
    this.currentTenantId$.next(undefined);
    localStorage.removeItem(TenantService.TENANT_LOCAL_STORAGE_KEY);
  }
}
